/**
 * Version du périmètre SFE (Système de Facturation d'Entreprise).
 *
 * PÉRIMÈTRE GELÉ — homologation DGI.
 *
 * La note DGI n°2025-0885 (voir docs/fiscal/2026-07-12-tva-facture-electronique.md)
 * impose une NOUVELLE homologation à chaque modification logicielle du
 * périmètre SFE certifié (signature MCF, numérotation séquentielle,
 * éléments de sécurité, QR code, format facture normalisée).
 *
 * Règle de release : cette constante n'est incrémentée QUE lorsqu'une
 * modification touche le périmètre SFE certifié, et chaque incrément
 * implique le dépôt d'un nouveau dossier d'homologation auprès de la
 * DGI (contact fec@dgi.bf — communiqué n°004 du 24/03/2026).
 * Les évolutions hors périmètre (compta, RH, CRM, UI) ne la modifient pas.
 */
export const SFE_VERSION = "1.0.0";
//# sourceMappingURL=sfe-version.js.map